import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { oneIdAuthAPI } from "@/auth/api/oneIdAuthAPI";
import { AuthContext } from "@/auth/context";
import { Types } from "@/auth/types";
import { paths } from "@/routes/paths";

export const useAuthWithOneId = () => {
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  return useCallback(
    async (code: string) => {
      try {
        // Make API call to authenticate with OneID
        const response = await oneIdAuthAPI.authenticate({ code });

        // Store tokens in localStorage
        localStorage.setItem("access_token", response.access);
        localStorage.setItem("refresh_token", response.refresh);
        localStorage.setItem("user", JSON.stringify(response.user));

        // Update auth context with user data
        dispatch({
          type: Types.AUTH_WITH_ONEID,
          payload: {
            user: {
              id: response.user.id,
              full_name: response.user.full_name,
              access_token: response.access,
              role: response.user.role || null,
              region: response.user.region ?? null,
              city: response.user.city ?? null,
              makhalla: response.user.makhalla ?? null,
            },
          },
        });

        toast.success("You have successfully signed in with ONE ID.");
        navigate(paths.dashboard.root);
      } catch (error: any) {
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Error signing in with ONE ID. Please try again.";
        toast.error(errorMessage);
        throw error;
      }
    },
    [dispatch, navigate],
  );
};
